import { DetailsData } from './DetailsData'

export class DownloadsData {
    public Id: number
    public Information: string
    public Details: DetailsData
    public PreviewImages: string[]
}
